import FormCompanyCreate from './FormCompanyCreate';
import FormCompanyDelete from './FormCompanyDelete';
import FormCompanyFilter from './FormCompanyFilter';
import FormCompanyUpdate from './FormCompanyUpdate';

export default Object.assign(
  {},
  {
    Create: FormCompanyCreate,
    Update: FormCompanyUpdate,
    Filter: FormCompanyFilter,
    Delete: FormCompanyDelete,
  },
);
